import { useNavigate } from "react-router-dom";
import { componentState } from "../../../../atoms/componentState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useState } from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import { FaMinus, FaPlus } from "react-icons/fa";
import ClientFilterSelect from "../../../../defaultComponents/ClientFilterSelect";
import { GRAY, VARIANT, WHITE } from "../../../../constants/colors";
import { goToAddVendaCorrente } from "../../../../routes/coordinator";
import TableVendasRecorrentes from "./tableVendasRecorrentes";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";
import { permissions } from "../../../../atoms/permissions";

export default function ListagemVendasRecorrentes() {
  const setHeaderLocation = useSetRecoilState(componentState);
  setHeaderLocation("Assinaturas");
  const navigate = useNavigate();

  const perms = useRecoilState(permissions)[0];

  const colors = useRecoilState(customColors)[0];

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");
  const idCliente = Number(jwtToken.idCliente);

  const initialValues = {
    clientFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  const [disable, setDisable] = useState(false);
  return (
    <Flex flexDir={"column"} height="100%" width="100%">
      <Box
        width={"99.8%"}
        bgColor={WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.2%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex
          justifyContent={"flex-end"}
          flexDirection={"row"}
          my={"auto"}
          px={8}
        >
          {/* <Box w={"22%"}>
            <ClientFilterSelect filtros={filtros} setFiltros={setFiltros} />
          </Box>
          <Box w={"22%"}>
            <Button
              leftIcon={<FaMinus />}
              style={{ color: "white" }}
              onClick={() => {
                setFiltros(initialValues);
              }}
              _hover={{ bg: "#4B4B57" }}
              bgColor={GRAY}
            >
              Limpar Filtro
            </Button>
          </Box> */}
          <Button
            leftIcon={<FaPlus />}
            style={{ color: "white" }}
            onClick={() => {
              goToAddVendaCorrente(navigate);
            }}
            _hover={{ bg: "#4B4B57" }}
            bgColor={colors.BLUEMONEDDBUTTONS}
          >
            Adicionar Assinatura
          </Button>
        </Flex>
      </Box>
      <Box
        w={"99.8%"}
        height={"80vh"}
        bgColor={WHITE}
        mt={"0.5%"}
        shadow={"md"}
        mx="auto"
        py={2}
        px={2}
      >
        <TableVendasRecorrentes idCliente={idCliente} />
      </Box>
    </Flex>
  );
}
